import React, { useState, useEffect } from 'react';
import API_BASE from '../config';

const CONTACT_EMAIL = 'heparese@gmail.com';

function HelpButton({ context, adminRole }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      const close = () => setOpen(false);
      document.addEventListener('click', close);
      return () => document.removeEventListener('click', close);
    }
  }, [open]);

  const manuals = [];

  if (context === 'registration') {
    manuals.push({ label: '📖 Manuale Genitori', type: 'genitori' });
  } else if (context === 'verify') {
    manuals.push({ label: '📖 Manuale Sicurezza', type: 'sicurezza' });
  } else if (context === 'admin') {
    if (adminRole === 'organizer') {
      manuals.push({ label: '📖 Manuale Organizzatori', type: 'organizzatori' });
      manuals.push({ label: '📖 Manuale Rappresentanti', type: 'rappresentanti' });
      manuals.push({ label: '📖 Manuale Sicurezza', type: 'sicurezza' });
      manuals.push({ label: '📖 Manuale Genitori', type: 'genitori' });
    } else {
      manuals.push({ label: '📖 Manuale Rappresentanti', type: 'rappresentanti' });
      manuals.push({ label: '📖 Manuale Sicurezza', type: 'sicurezza' });
      manuals.push({ label: '📖 Manuale Genitori', type: 'genitori' });
    }
  }

  return (
    <div className="help-button-wrapper">
      <button className="help-fab" onClick={(e) => { e.stopPropagation(); setOpen(!open); }} title="Aiuto e contatti">
        ?
      </button>
      {open && (
        <div className="help-menu" onClick={(e) => e.stopPropagation()}>
          <div className="help-menu-header">Aiuto</div>
          {manuals.map(m => (
            <a key={m.type} className="help-menu-item" href={`${API_BASE}/manuals/${m.type}`} target="_blank" rel="noopener noreferrer">
              {m.label}
            </a>
          ))}
          <div className="help-menu-divider" />
          <a className="help-menu-item" href={`mailto:${CONTACT_EMAIL}`}>
            ✉️ Contattaci
          </a>
        </div>
      )}
    </div>
  );
}

export default HelpButton;
